// Breadcrumbs
import Breadcrumbs from '@/components/ui/Breadcrumbs'

// Table
import RetailerEstimateTable from '@/components/retailers/RetailerEstimateTable'

// Next
import RouterLink from '@/components/ui/RouterLink'

// Mantine
import { Button } from '@mantine/core'

// Icons
import { Plus } from '@untitled-ui/icons-react'

export default function RetailerEstimatesIndex() {
    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Devis revendeurs',
        },
    ]

    const rightSection = (
        <Button component={RouterLink} href="/retailer_estimates/create" variant="light" color="dark" leftSection={<Plus width={14} height={14} />}>
            Créer un devis
        </Button>
    )

    return (
        <div>
            <Breadcrumbs
                breadcrumbs={breadcrumbs}
                rightSection={rightSection}
            />

            <RetailerEstimateTable />
        </div>
    )
}
